<div class="currency-converter modal">
    <div class="base-currency">
        <label for="price-to-convert">{{ data.labels.baseCurrency }}</label>
        @defer {
            <finder-ra-input
                #baseInput
                (inputEvent)="convert($event)"
                value="{{ 1 | currency }}"
                (keydownEvent)="handleCursorPosition($event)"
                (reference)="setInputComponent($event)"
                name="price-to-convert"
                id="price-to-convert"
                [ariaLabel]="data.labels.baseCurrency">
            </finder-ra-input>
        }
    </div>
    <div class="target-currency">
        <label class="label" for="converted-amount">
            {{ data.labels.targetCurrency }}
        </label>
        <input type="text"
            name="converted-amount"
            id="converted-amount"
            #targetInput
            readonly="readonly"
            class="input"
            aria-live="polite"
            role="alert"
            disabled>
    </div>
    <div class="disclaimer">
        {{
            data.disclaimer | ReplacePlaceholders: {
                BASE_CURRENCY_NAME: data.currency.baseCurrency.name,
                BASE_CURRENCY_CODE: data.currency.baseCurrency.code,
                TARGET_CURRENCY_NAME: data.currency.targetCurrency.name,
                TARGET_CURRENCY_CODE: data.currency.targetCurrency.code,
                CONVERSION_RATE: data.conversionRate
            }
        }}
    </div>
</div>
